module.exports = __webpack_public_path__ + "img/maker_maus.1471ec90.jpg";